import {AbstractStorageModule} from "@/services/storage/AbstractStorageModule";

export class Debug extends AbstractStorageModule {
    payload: any[] = [];
}